<template>
  <Dialog :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)" :title="$t('poolParty.record.title')" size="large">
    <div class="dialog-content" :class="cssType">
      <div class="table">
        <div class="thead" v-if="recordList.length > 0">
          <div class="th">
            <div class="th-item">{{ $t('poolParty.record.detailTitle') }}</div>
            <div class="th-item">{{ $t('poolParty.record.dateTitle') }}</div>
          </div>
        </div>
        <div class="tbody" v-if="recordList.length > 0">
          <div class="td" v-for="(item, index) in recordList" :key="index">
            <div class="td-item">
              <div class="prop" v-for="(prop, i) in item.propList" :key="i">
                {{ $t(`poolParty.prop.${prop.propId}`) }}*{{ prop.count }}
              </div>
            </div>
            <div class="td-item">
              {{ dayjs(item.claimTime).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </div>
        </div>
        <div class="no-data" v-if="recordList.length === 0">{{ $t('poolParty.record.noData') }}</div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import Dialog from '@/components/Dialog/ActPoolParty/index.vue'
import { defineProps, ref, watch } from 'vue'
import { isMobile } from '@/utils'
import PoolPartyActApi from '@/config/poolPartyActApi'
import dayjs from 'dayjs'
const cssType = isMobile ? 'mobile' : 'pc'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const recordList = ref([])
const getRewardRecord = async () => {
  const res = await PoolPartyActApi.getRewardRecord()
  recordList.value = res.recordList || []
}

watch(() => props.modelValue, async (newVal) => {
  if (newVal) {
    getRewardRecord()
  } else {
    recordList.value = []
  }
})

</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>